// Section title: 15 px blue semibold with the 3 by 15 px red bar, optional sub-line and right-aligned actions.
import type { ReactNode } from "react";

import { cn } from "@/lib/cn";

interface SectionTitleProps {
  title: ReactNode;
  sub?: ReactNode;
  actions?: ReactNode;
  as?: "h2" | "h3";
  id?: string;
  className?: string;
}

export function SectionTitle({ title, sub, actions, as: Heading = "h3", id, className }: SectionTitleProps) {
  return (
    <div className={cn("flex items-start justify-between gap-3", className)}>
      <div className="min-w-0">
        <Heading
          id={id}
          className="m-0 flex items-center gap-2.5 text-section font-semibold text-brand-blue before:h-[15px] before:w-[3px] before:shrink-0 before:rounded-[2px] before:bg-brand-red"
        >
          {title}
        </Heading>
        {sub ? <p className="m-0 mt-1 ml-[13px] text-chip text-muted-foreground">{sub}</p> : null}
      </div>
      {actions ? <div className="flex shrink-0 items-center gap-2">{actions}</div> : null}
    </div>
  );
}
